// extracted by mini-css-extract-plugin
export default {"outlet":"finances_outlet__ZLLnr","title":"finances_title__04n-X"};